export function initStickyHeader(): void {
    /*let scrollToTopBtn: Element | null = null;

    document.addEventListener('DOMContentLoaded', () => {
        scrollToTopBtn = document.querySelector('.scroll-to-top');
        scrollToTopBtn?.addEventListener('click', () => {
            const start = window.scrollY;
            const duration = 1200;
            const startTime = performance.now();
            const scroll = (now: number) => {
                const elapsed = Math.min((now - startTime) / duration, 1);
                const ease = 1 - Math.pow(1 - elapsed, 3);
                window.scrollTo(0, start * (1 - ease));
                if (elapsed < 1) requestAnimationFrame(scroll);
            };
            requestAnimationFrame(scroll);
        });
    });

    window.addEventListener('scroll', () => {
        const header = document.querySelector('.lds-theme header');
        if (!header) return;

        const scrolled = window.scrollY > 0;

        if (window.innerWidth < 768) {
            const btn = document.querySelector('.book-now-button--toggle');
            if (!btn) return;
            const headerBottom = header.getBoundingClientRect().bottom;
            const btnTop = btn.getBoundingClientRect().top;
            const isActive = btnTop <= headerBottom;
            header.classList.toggle('active', isActive);
            scrollToTopBtn?.classList.toggle('active', isActive);
        } else {
            header.classList.toggle('active', scrolled);
            scrollToTopBtn?.classList.toggle('active', scrolled);
        }
    });
*/
    const btn = document.querySelector('.book-now-button--toggle');
    const panel = document.querySelector('.booking-panel-container');

    if (btn && panel) {
        btn.addEventListener('click', () => {
            panel.classList.toggle('active');
        });
    }

    const closeBtn = document.querySelector('.booking-modal-container .hamburger');

    if (closeBtn && panel) {
        closeBtn.addEventListener('click', () => {
            panel.classList.remove('active');
        });
    }
}
